import React, { useState, useEffect } from "react";

import Details from "components/Notches/Details";
import Form from "components/Notches/Form";
import ConfirmationModal from 'components/ConfirmationModal/ConfirmationModal';

import List from "./help/List";

import axiosInstance from "utils/axiosInstance";
import { useLocalStorage, useSessionStorage } from "utils/storage";

import { fetchFavorites } from "services/favorites";

const Favorites = ({
    setShowContent
}) => {

    const [currentState, setCurrentState] = useState('list');

    const [selectedNotch, setSelectedNotch] = useState(null);
    const [notchToEdit, setNotchToEdit] = useState(null);

    const [favoritesInitialDataLoaded, setFavoritesInitialDataLoaded] = useSessionStorage("favoritesInitialDataLoaded", false);

    const [favorites, setFavorites] = useLocalStorage('favorites', []);
    const [deleteConfirmation, setDeleteConfirmation] = useState(null);
    const [notchTypes, setNotchTypes] = useState([
        { value: "notch", label: "Notch" },
        { value: "milestone", label: "Milestone" },
    ]);

    const handleAddItem = async (form) => {
        let response;

        if (form.uid) {
            response = await axiosInstance.post(`/api/favorites/${form.uid}`, form);
        } else {
            response = await axiosInstance.post("/api/favorites", form);
        }

        const itemInResponse = response.data.data;

        setFavorites((currentItems) => {
            const isEditing = currentItems.some(n => n.uid === itemInResponse.uid);

            if (isEditing) {
                return currentItems.map(item =>
                    item.uid === itemInResponse.uid ? itemInResponse : item
                );
            } else {
                return [...currentItems, itemInResponse];
            }
        });

        setCurrentState('list');
    };

    const handleDeleteNotch = async (uid) => {
        setDeleteConfirmation(uid);
    };

    const confirmDelete = async (deleteNotches) => {
        try {
            await axiosInstance.delete(`/api/favorites/${deleteConfirmation}`, {
                data: { delete_notches: deleteNotches }
            });

            setFavorites((favorites) => favorites.filter(n => n.uid !== deleteConfirmation));
            setCurrentState('list');
        } catch (error) {
            console.error('Failed to delete favorite:', error);
        } finally {
            setDeleteConfirmation(null);
        }
    };

    useEffect(() => {
        window.onbeforeunload = function() {
            sessionStorage.removeItem("favoritesInitialDataLoaded");
        };

        if (!favoritesInitialDataLoaded) {
            fetchFavorites().then((data) => {
                if (data) {
                    setFavorites(data);
                }
            });

            setFavoritesInitialDataLoaded(true);
        }
    });

    const handleOpenNotchDetails = async (item) => {
        setSelectedNotch(item);

        setCurrentState('details');
    }

    const handleEditNotch = (item) => {
        setNotchToEdit(item);

        setCurrentState('edit');
    }

    const handleCloseNotchDetails = (uid) => {
        // if uid is not null -> item was deleted
        if (uid !== null) {
            setFavorites((favorites) => favorites.filter(n => n.uid !== uid));

            // setFavorites((currentNotches) => {
            //     const remainingNotchesForDate = currentNotches.filter(n => n.date === selectedDate);

            //     return currentNotches;
            // });
        }

        setCurrentState('list')
    }

    const handleFormCancel = () => {
        setNotchToEdit(null);
        setCurrentState('list');
    }

    const handleBackButton = () => {
        setShowContent(false);
    }

    const renderCurrentView = () => {
        switch (currentState) {
            case "list":
                return (
                    <List
                        items={favorites}
                        onClickHandler={handleOpenNotchDetails}
                        onEditHandler={handleEditNotch}
                        onDeleteHandler={handleDeleteNotch}
                        onBackClick={handleBackButton}
                        setCurrentState={setCurrentState}
                    />
                );
            case "details":
                return (
                    <Details
                        item={selectedNotch}
                        onEditHandler={handleEditNotch}
                        onDeleteHandler={handleDeleteNotch}
                        onCloseHandler={handleCloseNotchDetails}
                    />
                );
            case "add":
            case "edit":
                return (
                    <Form
                        type='favorites'
                        notchTypes={notchTypes}
                        addItemHandler={handleAddItem}
                        onCancelHandler={handleFormCancel}
                        editingNotch={notchToEdit}
                    />
                );
            default:
                return <div>Unknown state</div>;
        }
    };

    return (
        <>
            {renderCurrentView()}

            <ConfirmationModal
                show={deleteConfirmation !== null}
                title="Delete Favorite"
                message="Do you want to delete all notches also?"
                onConfirm={() => confirmDelete(true)}
                onCancel={() => confirmDelete(false)}
            />
        </>

    );
};

export default Favorites;
